<template>
  <div>
    <div
      class="tw-relative tw-flex tw-flex-col tw-space-y-2 md:tw-flex-row md:tw-space-x-4 md:tw-space-y-0"
    >
      <div
        class="tw-flex tw-h-16 tw-w-16 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-neutral-200 tw-p-2"
      >
        <img :src="specialty.imagePath" loading="lazy" alt="" />
      </div>
      <div>
        <div class="tw-mb-2 tw-flex tw-items-center tw-justify-between">
          <h4 class="tw-heading-4">{{ specialty.name }}</h4>
          <div
            v-if="isEditModeEnabled"
            class="tw-absolute tw-right-0 tw-top-0 tw-flex tw-items-center tw-space-x-2 md:tw-relative"
          >
            <IconButton
              color="outline-secondary"
              @click="openModal(EDIT_MODAL_NAME)"
            >
              <PenIcon />
            </IconButton>
            <IconButton
              color="outline-red"
              @click="openModal(DELETE_MODAL_NAME)"
            >
              <BinIcon />
            </IconButton>
          </div>
        </div>
        <p class="tw-text-break tw-text-sm tw-text-neutral-600">
          {{ specialty.description }}
        </p>
      </div>
    </div>

    <template v-if="isEditModeEnabled">
      <ConfirmationModal
        :name="DELETE_MODAL_NAME"
        @confirmation="deleteSpecialty"
      />
      <ExpertiseModal
        :name="EDIT_MODAL_NAME"
        mode="EDIT"
        :specialty="specialty"
      />
    </template>
  </div>
</template>

<script setup>
import { getUniqueId } from '@/shared/utils/uniqueId.js'
import IconButton from '@/shared/components/IconButton.vue'
import ExpertiseModal from './ExpertiseModal.vue'
import ConfirmationModal from '@/shared/components/modals/ConfirmationModal.vue'
import PenIcon from '@/assets/images/icons/pen.svg'
import BinIcon from '@/assets/images/icons/bin.svg'
import { router } from '@inertiajs/vue3'
import { useEditProfileModeInjector } from '@/shared/composables/edit-profile-mode/useEditProfileModeInjector.js'
import { useModals } from '@/shared/composables/useModals.js'

const props = defineProps({
  specialty: {
    type: Object,
    required: true,
  },
})

const { isEditModeEnabled } = useEditProfileModeInjector()
const { openModal } = useModals()

const EDIT_MODAL_NAME = `growthmentor-expertise-modal-${getUniqueId()}`
const DELETE_MODAL_NAME = `growthmentor-expertise-confirmation-${getUniqueId()}`

const deleteSpecialty = () => {
  router.delete(`/profile/mentor/specialties/${props.specialty.id}`, {
    preserveScroll: true,
  })
}
</script>
